// extracted by mini-css-extract-plugin
export default {"block":"e76c581e7576683d"};